import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { ErrorPage } from 'containers';
import { getPortalHomePageData } from 'modules/menuitem/menuitem';
import { IUserLanguage } from 'models/user/userlanguage';
import { IUserPreferences } from 'models/user/userpreferences';
const { connect } = require('react-redux');
import { PortalPageSectionRenderer } from 'components/PortalPage/Sections';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router';
import { ILanguage } from 'models/common';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IMenuItemData, IMenuItemDataAction } from 'models/menuitem/menuitem';
import { IMainMenuData } from 'models/mainmenu/mainmenu';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
const InfiniteScroll = require('react-infinite-scroll-component');
const { asyncConnect } = require('redux-connect');

interface IProps extends RouteComponentProps<IParams, {}> {
	menuItemData: IMenuItemData;
	mainMenuData: IMainMenuData;
	userLanguage: IUserLanguage;
	languageDomainValues?: ILanguage[];
	userPreferences?: IUserPreferences;
	baseUrlClient?: string;
	location: any;
	t?: (x: string) => string;
	getPortalHomePageData: (culture: string, isFirstLoad: boolean, code: string) => IMenuItemDataAction;
}

interface IParams {
	culture?: string;
	code?: string;
}

@asyncConnect([
	{
		promise: ({ store: { dispatch, getState }, params }) => {
			const menuItemData = (getState as () => IStore)().menuItem;
			if (menuItemData && menuItemData.menuItem && menuItemData.menuItem.id) {
				return;
			}
			if (params.culture) {
				return Promise.all([dispatch(getPortalHomePageData(params.culture, true, null))]);
			} else if (params.code) {
				return Promise.all([dispatch(getPortalHomePageData(null, true, params.code))]);
			}
		},
	},
])
@connect(
	(state: IStore) => ({
		menuItemData: state.menuItem,
		userLanguage: state.userLanguage,
		languageDomainValues: state.domainValues.languages,
		userPreferences: state.userPreferences,
		baseUrlClient: state.fetchDefault.baseUrlClient,
		mainMenuData: state.mainMenu,
	}),
	(dispatch) => ({
		getPortalHomePageData: (culture: string, isFirstLoad: boolean, code: string) =>
			dispatch(getPortalHomePageData(culture, isFirstLoad, code)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewPortalPage extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
	}

	public loadMoreData() {
		if (this.props.params.culture) {
			this.props.getPortalHomePageData(this.props.params.culture, false, null);
		} else if (this.props.params.code) {
			this.props.getPortalHomePageData(null, false, this.props.params.code);
		}
	}

	public componentDidMount() {
		if (this.props.params.culture) {
			this.props.getPortalHomePageData(this.props.params.culture, true, null);
		} else if (this.props.params.code) {
			this.props.getPortalHomePageData(null, true, this.props.params.code);
		}
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.params.culture !== this.props.params.culture || prevProps.params.code !== this.props.params.code) {
			if (this.props.params.culture) {
				this.props.getPortalHomePageData(this.props.params.culture, true, null);
			} else if (this.props.params.code) {
				this.props.getPortalHomePageData(null, true, this.props.params.code);
			}
		}
		const items = this.props.menuItemData.items;
		const prevItems = prevProps.menuItemData.items;
		if (Array.isArray(prevItems) && Array.isArray(items) && prevItems.length !== items.length) {
			window.dispatchEvent(new Event('scroll'));
		}
	}

	public render() {
		let siteTitle = '';
		let siteDescription = '';
		let siteCode = '';
		let ogImage = '';

		const { items, itemsPage } = this.props.menuItemData;

		if (this.props.menuItemData && this.props.menuItemData.error) {
			return <ErrorPage {...this.props} message={this.props.menuItemData.message} />;
		}

		if (!this.props.menuItemData || !this.props.menuItemData.menuItem) {
			return null;
		}

		if (this.props.menuItemData && this.props.menuItemData.menuItem) {
			siteTitle = this.props.menuItemData.menuItem.title;
			siteDescription = this.props.menuItemData.menuItem.description;
			siteCode = this.props.menuItemData.menuItem.code;
			ogImage = (items as IPortalPageSection[]).find((sec) => sec.seoImageUrl)?.seoImageUrl || '';
		}

		const { userPreferences, baseUrlClient, userLanguage, t /*mainMenuData*/ } = this.props;
		const culture = userLanguage.culture;
		const linkToMagazine = '/magazine/' + culture.substring(0, 2);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: itemsPage.totalItems > items.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const sectionsContent: JSX.Element[] = [];
		const fullScreenSections: JSX.Element[] = [];
		if (items) {
			items.map((item, index) => {
				if (item.type === c.PORTAL_PAGE_SECTION_TYPE_3 || item.type === c.PORTAL_PAGE_SECTION_TYPE_1) {
					fullScreenSections.push(
						<PortalPageSectionRenderer
							key={index}
							portalPageSection={item}
							baseUrlClient={baseUrlClient}
							userPreferences={userPreferences}
							linkToMagazine={linkToMagazine}
						/>,
					);
				} else {
					sectionsContent.push(
						<PortalPageSectionRenderer
							key={index}
							portalPageSection={item}
							baseUrlClient={baseUrlClient}
							userPreferences={userPreferences}
							linkToMagazine={linkToMagazine}
						/>,
					);
				}
			});
		}

		return (
			<div className="portalContentWrapper topPadding">
				{fullScreenSections}
				<div className="landingContainer container">
					<InfiniteScroll {...infiniteScrollProps} className="landingContainer marqueeContainer">
						{sectionsContent}
					</InfiniteScroll>
				</div>
				<div className="clear" />
				<Helmet
					title={siteTitle}
					link={[{ rel: 'canonical', href: this.props.baseUrlClient + '/portal/page/' + siteCode }]}
					meta={[
						{ property: 'og:title', content: siteTitle },
						{ property: 'og:image', content: ogImage },
						{ property: 'og:description', content: siteDescription },
						{ property: 'og:url', content: this.props.baseUrlClient + '/portal/page/' + siteCode },
						{ name: 'title', content: siteTitle },
						{ name: 'description', content: siteDescription },
					]}
				/>
			</div>
		);
	}
}

export { ViewPortalPage };
